/* eslint-disable
    no-console,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class MoreFacetsService {
   $: any
   $filter: any
   $q: any
   alerts: any
   api: any
   appState: any
   config: any
   events: any
   facets: any
   results: any
   constructor(results: any, appState: any, facets: any, configService: any, api: any, events: any, $filter: any, alerts: any, $q: any) {
      this.getMoreFacets = this.getMoreFacets.bind(this)
      this.update = this.update.bind(this)
      this.updateFacet = this.updateFacet.bind(this)
      this.results = results
      this.appState = appState
      this.facets = facets
      this.api = api
      this.events = events
      this.$filter = $filter
      this.alerts = alerts
      this.$q = $q
      this.config = configService.data
   }

   getMoreFacets(facet: any) {
      if (facet.moreLoaded) {
         return this.$.reject('already loaded more for this facet')
      }
      return this.api.facetValues(facet.name, this.appState.params)
         .then((res: any) => {
            return this.update(res)
         }).catch((err: any) => {
            //TODO handle
            return console.error("more facets error", err)
         })
   }

   update(response: any) {
      const data = response.data.facet_values
      if (data != null) {
         let facet
         return facet = this.updateFacet(data[0])
      }
   }

   updateFacet(data: any) {
      if (!data) {
         console.error("No data received from more facet request")
         return
      }
      const facetToUpdate = _(this.facets.scope.facets).find((f: any) => f.name === data.display_name)
      _.each(data.counts, function(f: any) { 
         const hasFacetAlready = _.find(facetToUpdate.counts, (existingFacet: any) => existingFacet.value === f.value)
         if (!hasFacetAlready) {
            return facetToUpdate.counts.push(f)
         }
      })
    
      facetToUpdate.showmore = false
      facetToUpdate.moreLoaded = true
      this.facets.updateAppliedState(facetToUpdate) // checks if this facet has applied values and updates the data accordingly.
      return facetToUpdate
   }
}

MoreFacetsService.$inject = ['dataService', 'appStateService', 'facetsService', 'configService', 'apiService', 'eventService', '$filter', 'alertService', '$q']

angular.module('summonApp.services')
   .service('moreFacetsService', MoreFacetsService)
